export {
  SalesforceChatSupport,
  SALESFORCE_CHAT_END,
  SALESFORCE_CHAT_START,
} from "./SalesforceChatSupport";
export type {
  SalesforceConfig,
  SalesforceChatSupportContextValue,
} from "./SalesforceChatSupport";

// Login/Pre-authentication support chat
export {
  LoginSalesforceChatSupport,
  useLoginSalesforceChatSupport,
} from "./LoginSalesforceChatSupport";

// Authenticated user support chat
export {
  AuthenticatedSalesforceChatSupport,
  useAuthenticatedSalesforceChatSupport,
} from "./AuthenticatedSalesforceChatSupport";
